import { defineStore } from "pinia";

const MSG_UPLOAD_FAILED = "That file could not be uploaded. Please try again.";

export const useAppFileStore = defineStore("app-file-store", {
  actions: {
    uploadAppFile({ appName, publicationId, mediaType, file }, onUploaded, onFailed, onFinished) {
      if (!appName || !publicationId || !file) {
        if (onFailed) {
          onFailed(MSG_UPLOAD_FAILED);
        }
        if (onFinished) {
          onFinished();
        }
        return Promise.reject(new Error(MSG_UPLOAD_FAILED));
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("publication_id", publicationId);
      formData.append("media_type", mediaType || "any");

      return this.apiPost(
        `/app/${appName}/file`,
        formData,
        data => {
          onUploaded(data.url ?? "", data);
        },
        () => {
          if (onFailed) {
            onFailed(MSG_UPLOAD_FAILED);
          }
        },
        () => {
          if (onFinished) {
            onFinished();
          }
        },
      );
    },
  },
});
